import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "../../../components/ui/button";

export const Route = createFileRoute("/(pavilion)/pavilion/new")({
  component: NewAgent,
});

function NewAgent() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 overflow-auto bg-background">
      <div className="max-w-2xl mx-auto p-8">
        <div className="mb-6">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate({ to: "/pavilion" })}
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
        </div>

        <div className="text-center">
          <h1 className="text-2xl font-semibold mb-4">Create New Agent</h1>
          <p className="text-muted-foreground">
            Agent creation form coming soon...
          </p>
        </div>
      </div>
    </div>
  );
}
